module.exports = __webpack_public_path__ + "img/CoS.5c1bf47d.svg";